import { h } from "preact";
import Router from "preact-router";
import NavBar from "./NavBar";
import CornerHome from "./CornerHome";
import About from "./About";
import Skills from "./Skills";
import Exp from "./Exp";
import ProjectsPage from "./ProjectsPage";
import BlogPage from "./BlogPage";
import LearningPage from "./LearningPage";
import CornerContact from "./CornerContact";
import ResumePage from "./ResumePage";
import Footer from "./Footer";
import useCornerMotion from "./useCornerMotion";
const App = () => {
  useCornerMotion();
  return <div id="app">
    <NavBar />

    <Router>
      <CornerHome default />
      <ProjectsPage path="/projects" />
      <BlogPage path="/writing" />
      <BlogPage path="/blog" />
      <LearningPage path="/me" />
      <ResumePage path="/resume" />
      <Exp path="/exp" />
      <Skills path="/skills" />
      <About path="/about" />
      <CornerContact path="/contact" />
    </Router>
    <Footer />
  </div>;
};

export default App;
